module.exports = __webpack_public_path__ + "img/1560929889.f4e26429.jpg";